import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ConsumptionState } from '@store/states/consumption.state';

const consumptionFeatureSelector = createFeatureSelector<ConsumptionState>('consumption');

export const consumptionSelectors = {
  mapGeometry: createSelector(consumptionFeatureSelector, (state) => state.map.geometry),
  mapGeometryError: createSelector(consumptionFeatureSelector, (state) => state.map.errorGeometry),
  mapCoords: createSelector(consumptionFeatureSelector, (state) => state.map.coords),
  mapCoordsError: createSelector(consumptionFeatureSelector, (state) => state.map.errorCoords),
  mapFilter: createSelector(consumptionFeatureSelector, (state) => state.map.filter),
  requestList: createSelector(consumptionFeatureSelector, (state) => state.requestList.data),
  requestListError: createSelector(consumptionFeatureSelector, (state) => state.requestList.error),
  requestListFilter: createSelector(consumptionFeatureSelector, (state) => state.requestList.filter),
  requestListPage: createSelector(consumptionFeatureSelector, (state) => state.requestList.page),
  requestListSort: createSelector(consumptionFeatureSelector, (state) => state.requestList.sort),
  currentTab: createSelector(consumptionFeatureSelector, (state) => state.currentTab),
  tabs: createSelector(consumptionFeatureSelector, (state) => state.tabs),
  currentTabIndex: createSelector(consumptionFeatureSelector, (state) => state.tabs.indexOf(state.currentTab)),
  accumulatedFilter: createSelector(consumptionFeatureSelector, (state) => state.graphs.accumulated.filter),
  accumulatedGraphType: createSelector(consumptionFeatureSelector, (state) => state.graphs.accumulated.graphType),
  accumulatedData: createSelector(consumptionFeatureSelector, (state) => {
    const previousData = state.graphs.accumulated.previousData;
    const currentData = state.graphs.accumulated.currentData;
    if (!!previousData || !!currentData) {
      return { previousData, currentData };
    }
    return null;
  }),
  comparativeFilter: createSelector(consumptionFeatureSelector, (state) => state.graphs.comparative.filter),
  comparativeGraphType: createSelector(consumptionFeatureSelector, (state) => state.graphs.comparative.graphType),
  comparativeData: createSelector(consumptionFeatureSelector, (state) => state.graphs.comparative.data),
  comparativeError: createSelector(consumptionFeatureSelector, (state) => state.graphs.comparative.error),
};
